
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { AgencyRelationship } from '../../global/models'
import SplitDisplay from './RelationshipSplitDisplay.vue'
import InternalRelationshipCard from './InternalRelationshipCard.vue'

@Component({
  components: { SplitDisplay, InternalRelationshipCard }
})
export default class RelationshipDisplay extends Vue {
  @Prop({ type: Object, required: true })
  private readonly relationship!: AgencyRelationship
}
